import React from 'react'
import { Flex, Box } from 'reflexbox'
import { useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'

import Breadcrumb from 'components/Breadcrumb'
import Card from 'components/Card'
import { Title } from 'components/Typography'
import Button from 'components/Button'
import { TextField } from 'components/Form'
import Loader from 'components/Loader'
import PasswordFormatValidation from 'components/PasswordFormatValidation'

import { useUser } from 'context/user-context'
import { updatePassword } from 'services/users'

const validationSchema = Yup.object().shape({
  current_password: Yup.string().required('Campo obrigatório'),
  new_password: Yup.string()
    .min(6, 'A senha precisa conter os itens abaixo para ser válida.')
    .matches(/\w*[A-Za-z]\w*/, 'A senha precisa conter os itens abaixo para ser válida.')
    .matches(/.*[0-9].*/, 'A senha precisa conter os itens abaixo para ser válida.')
    .required('A senha precisa conter os itens abaixo para ser válida.'),
  new_password_confirmation: Yup.string()
    .oneOf([Yup.ref('new_password')], 'As senhas não correspondem')
    .required('Campo obrigatório'),
})

const SettingsEditPassword = () => {
  const {
    user: { id },
  } = useUser()

  const history = useHistory()

  const handleSubmit = async values => {
    try {
      await updatePassword(id, values)

      toast.success('Senha alterada com sucesso!')
      history.goBack()
    } catch (e) {
      console.log(e)
      if (e.response.status >= 500) {
        toast.error(
          'Não foi possivel alterar a senha. Serviço temporariamente indisponível, tente novamente mais tarde.',
        )
      } else if (e.response.status == 403) {
        toast.error('Não foi possivel alterar a senha. A senha atual está incorreta.')
      } else {
        toast.error('Não foi possivel alterar a senha.')
      }
    }
  }

  return (
    <Flex flexDirection='column'>
      <Breadcrumb children={[{ label: 'Configurações', link: '/staff/settings' }, { label: 'Alterar senha' }]} />
      <Title as='h3'>Alterar senha</Title>
      <Card mt='24px'>
        <Formik
          validationSchema={validationSchema}
          initialValues={{ current_password: '', new_password: '', new_password_confirmation: '' }}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, values }) => (
            <Form>
              <Box maxWidth={384}>
                <TextField mb={32} type='password' label='Senha Atual' name='current_password' />

                <TextField type='password' label='Nova Senha' name='new_password' mb={32} />
                {PasswordFormatValidation(values.new_password)}

                <TextField mb={32} type='password' label='Confirmar Senha' name='new_password_confirmation' />

                <Flex>
                  <Button type='button' outlined onClick={history.goBack}>
                    Cancelar
                  </Button>
                  <Button type='submit' ml='24px' disabled={isSubmitting}>
                    {isSubmitting ? <Loader /> : 'Salvar'}
                  </Button>
                </Flex>
              </Box>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  )
}

export default SettingsEditPassword
